<template>
    <header id="header">
      <div id="header-box">
        <template v-if="spWidth">
          <router-link 
          to="/" 
          class="header-title" 
          tag="h1"><span>旅</span>のしおり</router-link>
        </template>
        <template v-else-if="changeHeadTitle">
          <router-link 
          to="/" 
          class="header-title" 
          tag="h1"><span>旅</span>のしおり</router-link>
        </template>
        <template v-else>
          <router-link 
          to="/" 
          class="header-title original" 
          tag="h1">{{ shioriTitle }}</router-link>
        </template>
        <nav :class="{ under:underNav }" id="header-nav">
          <ul id="header-items">
            <li class="header-item" id="howto-link">
              <router-link 
              active-class="item-i-active" 
              to="/howto" 
              class="header-item-i" 
              ><i class="fas fa-question"></i></router-link>
            </li>
            <li class="header-item">
              <router-link
              active-class="item-a-active" 
              exact
              to="/about" 
              class="header-item-a"
              >概要</router-link>
            </li>
            <li class="header-item">
              <router-link
              active-class="item-a-active" 
              exact
              to="/items" 
              class="header-item-a">持ち物</router-link>
            </li>
            <li class="header-item">
              <router-link
              active-class="item-a-active" 
              exact
              to="/schedule" 
              class="header-item-a"
              >旅程</router-link>
            </li>
            <li class="header-item">
              <router-link
              active-class="item-a-active" 
              exact
              to="/kyouyu" 
              class="header-item-a"
              >共有</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
</template>

<script>
export default {
  props: {
    underNav: {
      type: Boolean,
      required: true
    },
    spWidth: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    shioriTitle() {
      return this.$store.getters.shioriTitle;
    },
    changeHeadTitle: {
      get() {
        return this.$store.getters.changeHeadTitle;
      },
    },
  },
}
</script>
